import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {GroupModel} from '../Models/group-model';
import {map, tap} from 'rxjs/operators';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GroupService {

  public groups: GroupModel[];
  private headers = new Headers({'Content-Type': 'application/json'});

  constructor(private http: HttpClient) {
  }

  public loadGroups(clientId: number): void {
    this.groups = [];
    this.http.get<GroupModel[]>(`${environment.baseURl}/api/decisionGrid/group/GetGroups/${clientId}`).subscribe((r: GroupModel[]) => this.groups = r);
  }

  public saveNewGroup(group: GroupModel): Observable<any> {
    return this.http.post(environment.baseURl + '/api/decisionGrid/group/SaveGroup', group)
      .pipe(
        tap((e: GroupModel) => this.groups.push(e)),
        map(res => res));
  }

  public updateGroup(group: GroupModel): Observable<any> {
    // find the group and update it in memory

    return this.http.post(environment.baseURl + '/api/decisionGrid/group/SaveGroup', group)
      .pipe(
        tap(e => {
          const idx = this.groups.findIndex((l: GroupModel) => l.id === group.id);
          this.groups[idx] = group;
        }),
        map(res => res));
  }
}
